module.exports = __webpack_public_path__ + "static/media/castles.d035554c.png";